import { Http } from '../../../support';

const initialState = {
  busy: false,
  result: undefined,
  error: undefined,
};

const download = async (store, uuid, kind) => {
  store.setState((state) => {
    state.app.retenciones.download.busy = true;
  });

  try {
    const params = {
      type: kind || 'zip',
      as: 'link',
    };

    const response = await Http.get(`${window.BONJOUR_URL}/api/retenciones/${uuid}/download`, { params });

    store.setState((state) => {
      state.app.retenciones.download.busy = false;
      state.app.retenciones.download.result = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.retenciones.download.busy = false;
      state.app.retenciones.download.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.app.retenciones.download.error = undefined;
};

const resetResult = (store) => (state) => {
  state.app.retenciones.download.busy = false;
  state.app.retenciones.download.result = undefined;
};

const reset = (store) => (state) => {
  state.app.retenciones.download = {
    ...initialState,
  };
};

const actions = {
  download,
  reset,
  resetError,
  resetResult,
};

const RetencionesDownloadStore = {
  state: () => initialState,
  actions,
};

export default RetencionesDownloadStore;
